const constants = {
  GREENERS_URL: process.env.GREENERS_URL,
  appname: 'wla crm',
  routes: {
    mainMenu: []
  },
  commentType: [
    { value: 'common', label: 'Allgemein' },
    { value: 'payment', label: 'Zahlung' }
  ],
  variablesMapping: {
    orders: {
      preferredDateOfDelivery: 'preferred_date_of_delivery',
      dateOfInvoice: 'date_of_invoice',
      paymentTerm: 'payment_term',
      productExpiry: 'product_expiry',
      tracking_number: 'tracking_number'
    }
  },
  formmsg: {
    empty: 'Dieses Feld muss ausgefüllt sein',
    nePwd: 'Die Passwörter stimmen nicht überein',
    pwdReqSpecialChar: 'Muss ein Sonderzeichen enthalten',
    pwdReqNumber: 'Muss mindestens eine Zahl enthalten',
    pwdReqAlpha: 'Muss sowhol Groß- als auch Kleinbuchstaben enthalten',
    pwdReqMin: 'Muss mindestens 8 Zeichen lang sein',
    phone: 'Diese Tel. Format ist nicht gültig',
    email: 'Diese E-Mail Format ist nicht gültig',
    paymentAmount: 'Der Betrag muss > 0.00 € sein.'
  },
  emailSubjectsByStatus: {
    draft: '',
    inbox: 'Rezept erhalten - Cannabis Apotheke',
    processing: 'Ihr Rezept wird bearbeitet - Cannabis Apotheke',
    support: 'Ihr Rezept wird bearbeitet - Cannabis Apotheke',
    support_prio: 'Ihr Rezept wird bearbeitet - Cannabis Apotheke',
    laboratory: 'Ihr Rezept wird bearbeitet - Cannabis Apotheke',
    laboratory_prio: 'Ihr Rezept wird bearbeitet - Cannabis Apotheke',
    split_delivery: 'Teillieferung - Cannabis Apotheke',
    subsequent_delivery: 'Nachlieferung - Cannabis Apotheke',
    no_date_of_delivery: 'Wichtig – Liefertermin – Cannabis Apotheke',
    no_date_of_delivery_with_internal_shipping: 'Wichtig – Botenteilfermin – Cannabis Apotheke',
    approval: 'Ruecksprache – Cannabis Apotheke',
    ready_to_ship_pickup: 'Ihre Bestellung ist abholbereit - Cannabis Apotheke',
    cancellation: '',
    sent: '',
  },
  orderStatusOptions: [
    { value: 'draft', label: 'Entwurf' , id : 0},
    { value: 'draft_payment_preference', label: 'Entwurf - Zahlungspräferenz' , id : 0.5},
    { value: 'inbox', label: 'Eingegangen' , id : 1},
    { value: 'support', label: 'Callcenter' , id : 3 },
    { value: 'laboratory', label: 'Labor' ,id : 5 },
    { value: 'processing', label: 'Rezept-Bearbeitung' , id : 2},
    { value: 'ready_to_ship', label: 'Versandbereit / Abholbereit' ,id : 12 },
    { value: 'sent', label: 'Versendet / Ware übergeben', id : 14},
    { value: 'payment_status_paid', label: 'Zahlungsstatus bezahlt', id : 15},
    { value: 'cancellation', label: 'Storno', id : 16},
  ],
  additionalOrderStatuses: [
    { value: 'ready_to_ship_nopickup_nochilled', label: 'Versandbereit /  Keine Abholung' ,id : 13 },
    { value: 'processing', label: 'Rezept-Bearbeitung',id:2 },
    // { value: 'laboratory_and_prio', label: 'Labor / Labor-Prio ',id:2.1 },
    // { value: 'support_and_prio', label: 'Callcenter / Callcenter-Prio',id:2.2 },
    { value: 'support_prio', label: 'Callcenter-Prio', id : 4 },
    { value: 'laboratory_prio', label: 'Labor-Prio',id : 6},
    { value: 'split_delivery', label: 'Teilbelieferung' , id : 7},
    { value: 'subsequent_delivery', label: 'Nachlieferung' ,id : 8},
    { value: 'no_date_of_delivery', label: 'Freigegeben - ohne Liefertermin' , id : 9},
    { value: 'no_date_of_delivery_with_internal_shipping', label: 'Freigegeben - ohne Liefertermin mit internem Versand' , id : 10},
    { value: 'no_date_of_delivery_with_not_assign', label: 'Freigegeben – ohne Liefertermin mit ohne Zuordnung' , id : 10.5},
    { value: 'approval', label: 'Freigegeben-Rücksprache' , id : 11},
  ],
  dateInboxStatuses : ["inbox", "laboratory", "laboratory_prio", "support", "support_prio", "processing", "split_delivery", "subsequent_delivery"],
  geneticOptions: [
    { value: null, label: 'n.a.' },
    { value: 'indica', label: 'Indica' },
    { value: 'sativa', label: 'Sativa' },
    { value: 'hybrid', label: 'Hybrid' }
  ],
  deliveryTypeOptions: [
    { value: 'n.a.', label: 'n.a.' },
    { value: 'pickup', label: 'Abholer' },
    { value: 'internal_shipping', label: 'Botendienst' },
    { value: 'dhl_express', label: 'DHL Express' },
    { value: 'dhl', label: 'DHL' },
    { value: 'go_express', label: 'GO! Express' },
    { value: 'urbify', label: 'Urbify' },
    { value: 'urbify_next_day', label: 'Urbify Next Day' },
    { value: 'uber_eats', label: 'Uber Eats' },
    { value: 'label_created', label: 'Versandetikett erstellt' },
    { value: 'label_not_created', label: 'Versandetikett nicht erstellt' },
    { value: 'packstation', label: 'Packstation' }
  ],
  deliveryConfirmationFilters: [
  { value: 'change_requested', label: 'Änderung angefragt' },
  { value: 'confirmed_delivery', label: 'Bestätigte Lieferart' },
  { value: 'in_review', label: 'In der Prüfung' }
  ],
  deliveryTypeOptionsModal: [
    { value: 'n.a.', label: 'n.a.' },
    { value: 'pickup', label: 'Abholer' },
    { value: 'internal_shipping', label: 'Botendienst' },
    { value: 'dhl_express', label: 'DHL Express' },
    { value: 'dhl', label: 'DHL' },
    { value: 'go_express', label: 'GO! Express' },
    { value: 'urbify', label: 'Urbify' },
    { value: 'urbify_next_day', label: 'Urbify Next Day' },
    { value: 'uber_eats', label: 'Uber Eats' },
  ],
  deliveryPeriodOptions: [
    { value: null, label: '' },
    { value: 'morning', label: 'Vormittag 8-12' },
    { value: 'end_of_day', label: 'End of day 8-18' }
  ],
  paymentTypeOptions: [
    { value: 'miscellaneous', label: 'Sonstige' },
    { value: 'prepayment', label: 'Vorkasse' },
    { value: 'on_site_payment', label: 'vor Ort Zahlung' },
    { value: 'paid', label: 'Bezahlt' },
    { value: 'open', label: 'Nicht bezahlt' },
  ],
  invoiceTypeFilterOptions: [
    { value: 'fastbill', label: 'Fastbill', id : 1 },
    { value: 'miscellaneous', label: 'Sonstige' , id : 2 },
    { value: 'cardflo', label: 'Cardflo', id : 2.5},
    { value: 'on_site_payment', label: 'vor Ort Zahlung',id : 3 },
    { value: 'paid', label: 'Bezahlt' , id : 4 },
    { value: 'open', label: 'Nicht bezahlt', id : 5 },
    { value: 'not_assigned', label: 'n.a.' , id : 6 },
  ],
  invoiceTypeOptions: [
    { value: 'fastbill', label: 'Fastbill' },
    { value: 'miscellaneous', label: 'Sonstige' }
  ],
  paymentStatusOptions: [
    { value: 'draft', label: 'Entwurf' },
    { value: 'open', label: 'Rechnung versendet' },
    { value: 'partially_paid', label: 'zum Teil bezahlt' },
    { value: 'paid', label: 'bezahlt' },
    { value: 'under_review', label: 'Zahlungsprüfung' }
  ],
  nameFilterOptions : [
    { value: 'invoice_customer', label: 'Rechnungskunde' },
    { value: 'prepayment_customer', label: 'Vorkassenkunde' }
  ],
  paymentPreferenceFilterOptions: [
    { value: 'invoice', label: 'Rechnung' },
    { value: 'card', label: 'Zahlungslink' },
  ],
  days: [
    {
      short: 'Mo',
      long: 'Montag'
    },
    {
      short: 'Tu',
      long: 'Dienstag'
    },
    {
      short: 'We',
      long: 'Mittwoch'
    },
    {
      short: 'Th',
      long: 'Donnerstag'
    },
    {
      short: 'Fr',
      long: 'Freitag'
    },
    {
      short: 'Sa',
      long: 'Samstag'
    },
    {
      short: 'Su',
      long: 'Sontag'
    }
  ],
  productTypes: [
    'Extrakte',
    'abgeglichen',
    'ausstehend',
    'mit Anhang',
    'ohne Anhang'
  ],
  localeDatePicker: {
    /* starting with Sunday */
    days: ['Sontag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
    daysShort: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
    months: [
      'Januar',
      'Februar',
      'März',
      'April',
      'Mai',
      'Juni',
      'Juli',
      'August',
      'September',
      'Oktober',
      'November',
      'Dezember'
    ],
    monthsShort: ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
    firstDayOfWeek: 1,
    format24h: true,
    pluralDay: 'Tage'
  }
};
const variableSuggestionJSON = {
  Kundendaten: [
    { label: 'Vorname (Kunde)', value: '{{orders.customer.firstname}}'},
    { label: 'Nachname (Kunde)', value: '{{orders.customer.lastname}}'},
  ],
  Bestelldaten: [
    { label: 'Bestellnummer', value: '{{orders.orders_id}}'},
    { label: 'Geplantes Lieferdatum', value: '{{orders.preferred_date_of_delivery}}'},
    { label: 'Standort', value: '{{location.company}}'},
    { label: 'Sendungsnummer', value: '{{orders.tracking_number}}'},
    { label: 'Lieferart', value: '{{orders.delivery_type}}'},
    { label: 'Lieferadresse', value: '{{orders.delivery_address}}'},
  ],
  Bilder: [
    { label: 'Bild 1', value: '{{attachments.0.directus_files_id.id}}'},
    { label: 'Bild 2', value: '{{attachments.1.directus_files_id.id}}'},
    { label: 'Bild 3', value: '{{attachments.2.directus_files_id.id}}'},
  ],
  Apothekenidentität: [
    { label: 'Logo in der E-Mail', value: '{{orders.email_logo}}'},
    { label: 'Apothekenname', value: '{{pharmacy.title}}'},
    { label: 'Apothekenname (Nachname)', value: '{{pharmacy.last_name}}'},
    { label: 'Öffnungszeiten', value: '{{location.working_hours}}'},
  ],
  Kontaktdaten: [
    { label: 'Telefonnummer (Apo)', value: '{{pharmacy.phone}}'},
    { label: 'E-Mail-Adresse (Apo)', value: '{{pharmacy.contact_email}}'},
    { label: 'Webseite', value: '{{pharmacy.website}}'},
    { label: 'Straße (Apo)', value: '{{pharmacy.street}}'},
    { label: 'PLZ (Apo)', value: '{{pharmacy.zip}}'},
    { label: 'Stadt (Apo)', value: '{{pharmacy.city}}'},
    { label: 'Amtsgericht', value: '{{pharmacy.local_court}}'},
    { label: 'HRA-Nummer', value: '{{pharmacy.hra_number}}'},
    { label: 'Datenschutz-URL', value: '{{pharmacy.privacy_url}}'},
    { label: 'Impressum-URL', value: '{{pharmacy.impressum_url}}'},
  ],
  Zahlungspräferenz: [],
  Zustellbestätigung: [
    { label: 'start-liefermethode-praeferenz', value: '{{reqopener}}' },
    { label: 'Änderungswunsch der Lieferadresse', value: '{{request_delivery_change}}'},
    { label: 'ende-liefermethode-praeferenz', value: '{{reqcloser}}' },
  ],
  Prepaid: [
    { label: 'nur-prepaid-start', value: '{{nur_prepaid_start}}' },
    { label: 'nur-prepaid-ende', value: '{{nur_prepaid_ende}}' },
    { label: 'ohne-prepaid-start', value: '{{ohne_prepaid_start}}' },
    { label: 'ohne-prepaid-ende', value: '{{ohne_prepaid_ende}}' },
  ],
};

const PREPAID_CONDITIONAL_BASE_TAGS = [
  { label: 'nur-prepaid-start', value: '{{nur_prepaid_start}}' },
  { label: 'nur-prepaid-ende', value: '{{nur_prepaid_ende}}' },
  { label: 'ohne-prepaid-start', value: '{{ohne_prepaid_start}}' },
  { label: 'ohne-prepaid-ende', value: '{{ohne_prepaid_ende}}' },
];

const unitOptions = [
  { value: 'mg/ml', label: 'mg/ml' },
  { value: 'mg/g', label: 'mg/g' }
];

const packagingUnitOptions = [
  { value: null, label: 'n.a.' },
  { value: 'mg', label: 'mg' },
  { value: 'g', label: 'g' },
  { value: 'ml', label: 'ml' },
  { value: 'l', label: 'l' },
  { value: 'pcs', label: 'Stück' }
];

const equalityOptions = [
  { value: null, label: 'n.a.' },
  { value: '<', label: '<' },
  { value: '>', label: '>' }
];

const geneticOptions = [
  { value: null, label: 'n.a.' },
  { value: 'indica', label: 'Indica' },
  { value: 'sativa', label: 'Sativa' },
  { value: 'hybrid', label: 'Hybrid' }
];

const geneticdominanceOptions = [
  { value: null, label: 'n.a.' },
  { value: 'indica', label: 'Indica' },
  { value: 'sativa', label: 'Sativa' }
];

const calculationBaseOptions = [
  { value: null, label: 'n.a.' },
  { value: 'thc', label: 'THC' },
  { value: 'cbd', label: 'CBD' }
];

const extractOutputTypeOptions = [
  { value: null, label: 'n.a.' },
  { value: 'thc', label: 'THC' },
  { value: 'cbd', label: 'CBD' },
  { value: 'thc_cbd', label: 'THC & CBD' },
  { value: 'custom', label: 'Benutzerdefiniert' },
  { value: 'special', label: 'Extraktabfüllung' }
];

const baseOilOptions = [
  { value: null, label: 'n.a.' },
  { value: 'MCT', label: 'MCT' },
  { value: 'MCT & Vitamin E', label: 'MCT & Vitamin E' },
  { value: 'Seasamöl', label: 'Sesamöl' },
  { value: 'Olivenöl', label: 'Olivenöl' }
];

const manufacturingprocessOptions = [
  { value: null, label: 'n.a.' },
  { value: 'ethanol', label: 'Ethanol Extraktion' },
  { value: 'CO2', label: 'CO2-Extraktion' },
  { value: 'soxhlet', label: 'Soxhlet' },
  { value: 'ethanol_tween', label: 'Ethanol-/Tweenextraktion' }
];

const mappedBudsFields = [
  'id',
  'name',
  'cultivar',
  'genetic',
  'dominance',
  'radiationstate',
  'manufacturer',
  'origin_country',
  'origin_grower',
  'thc',
  'equality_thc',
  'cbd',
  'equality_cbd'
];

const mappedExtractFields = [
  'id',
  'name',
  'cultivar',
  'genetic',
  'manufacturer',
  'origin_country',
  'equality_thc',
  'thc',
  'equality_cbd',
  'cbd',
  'unit',
  'manufacturingprocess',
  'baseoil',
  'conf_outputtype',
  'conf_calculationbase'
];
const radiotionOptions = [
  { value: null, label: '-' },
  { value: 'true', label: 'bestrahlt' },
  { value: 'false', label: 'unbestrahlt' }
];
const mappedOrderFields = [
  'id',
  'date_created',
  'date_updated',
  'user_created',
  'user_updated',
  'responsible_employee',
  'date_of_closure',
  'archived',
  'status',
  'orders_id',
  'current_editor',
  'customer',
  'location',
  'location_short_name',
  'ext_invoice_number',
  'cancelled_invoice_numbers',
  'date_of_invoice',
  'date_of_last_payment_check',
  'payment_status',
  'payment_type',
  'payment_amount',
  'date_of_payment',
  'date_of_payment_confirmation',
  'payment_term',
  'delivery_type',
  'delivery_period',
  'delivery_price',
  'excess_delivery_price',
  'billing_adress',
  'delivery_address',
  'preferred_date_of_delivery',
  'delivery_adress',
  'date_of_delivery',
  'no_prescription',
  'handover_delivery_date',
  'product_expiry',
  'last_comment',
  'comments_total',
  'priority',
  'callcenter_prio_status',
  'tracking_number',
  'source',
  'prepaid_by_MCOS',
  'prepaid',
  'marked_delete',
  'on_site_payment',
  'invoice_type',
  "items",
  "external_order_id",
  "payment_options",
  'desired_date',
  "inbox",
  "files",
  "mark_as_complete",
  "date_inbox",
  "payment_link_id",
  "is_delivery_method_approved",
  "requested_delivery_method",
  "requested_pickup_location"
];

/** allowed_operations flag that switches a pharmacy onto the V2 CardFlo endpoints. */
const CARDFLO_V2_OPERATION = "cardflo_integrations_v2";

/** Pharmacy is on V2: governs which API *creates* a new payment link. */
const isCardfloV2Enabled = (user) =>
  Array.isArray(user?.cu?.allowed_operations) &&
  user.cu.allowed_operations.includes(CARDFLO_V2_OPERATION);

/** Link was issued by V2: governs which API cancels, refunds or checks it. Not the pharmacy flag, or older links would be orphaned. */
const isOrderOnCardfloV2 = (order) =>
  order?.isNewCardfloIntegration === true ||
  order?.is_new_cardflo_integration === true;

/** Order fields to reset once a CardFlo payment link is cancelled/expired. */
const CARDFLO_ORDER_RESET_FIELDS = {
  payment_link: null,
  payment_link_id: null,
  payment_provider: null,
  payment_provider_txn_amount: null,
  payment_provider_payment_status: null,
  payment_provider_txn_id: null,
  is_new_cardflo_integration: false,
};

/** Directus realtime subscribe fields: `*` plus explicit relation paths so M2O values are objects, not bare FK strings. */
const ORDER_REALTIME_SUBSCRIBE_FIELDS = [
  '*',
  'customer.id',
  'customer.firstname',
  'customer.lastname',
  'customer.email',
  'customer.phone',
  'customer.orders_count',
  'customer.insurance_state',
  'customer.group',
  'customer.ext_customer_id',
  'customer.billing_adress',
  'customer.delivery_adress',
  'location.id',
  'location.short_name',
  'location.company',
  'responsible_employee.id',
  'responsible_employee.first_name',
  'responsible_employee.last_name',
  'responsible_employee.role',
  'current_editor.id',
  'current_editor.first_name',
  'current_editor.last_name',
  'current_editor.role',
  'last_comment.id',
  'last_comment.content',
  'user_created.id',
];

const ORDER_REALTIME_SUBSCRIBE_FIELDS_FOR_SINGLE_ORDER = [
  '*',
  'items.*',
  'items.label_config.*',
  'customer.id',
  'customer.user_created',
  'customer.date_created',
  'customer.user_updated',
  'customer.date_updated',
  'customer.ext_customer_id',
  'customer.gender',
  'customer.firstname',
  'customer.lastname',
  'customer.date_of_birth',
  'customer.email',
  'customer.phone_alt',
  'customer.phone',
  'customer.permission_auto_response',
  'customer.billing_adress',
  'customer.delivery_adress',
  'customer.sepa',
  'customer.recommendation',
  'customer.insurance_state',
  'customer.billing_address_validated',
  'customer.delivery_address_validated',
  'customer.group',
  'customer.orders_count',
  'customer.password',
  'customer.verified',
  'customer.sepa_url',
  'customer.pdf',
  'customer.marked',
  'customer.pharmacy_remarks',
  'customer.invoice_customer',
  'customer.payment_preference',
  'location.id',
  'location.short_name',
  'location.company',
  'responsible_employee.id',
  'responsible_employee.first_name',
  'responsible_employee.last_name',
  'responsible_employee.role',
  'current_editor.id',
  'current_editor.first_name',
  'current_editor.last_name',
  'current_editor.role',
  'last_comment.id',
  'last_comment.content',
  'user_created.id',
];

const userFields = [
  'id',
  'email',
  'first_name',
  'last_name',
  'role',
  'status',
  'pharmacy_token',
  'main_pharmacy',
  'manufacturing_instructions',
  'show_kpi_dashboard',
  'show_auswertungen_tab',
  'show_remarks',
  "show_custom_email",
  "show_all_statuses",
  "allowed_operations",
  "allowed_bulk_operations",
  "allow_onestop_operations",
  'enable_third_product_category'
];
const mainPharmacyFields = [
  'id',
  'pharmacy_token',
  'show_import_csv_tab',
  'allowed_operations',
  'allowed_bulk_operations',
  'enable_doctors_csv_report',
  'enable_third_product_category',
  'allowed_delivery_sources',
  'hidden_providers',
  'delivery_request_timeout',
  'mwst_percent'
];

const meRequestFields = [
  ...userFields.filter((field) => field !== 'role' && field !== 'main_pharmacy'),
  'role.name',
  ...mainPharmacyFields.map((field) => `main_pharmacy.${field}`)
];

const greenersUserFields = [
  'id',
  'title',
  'location',
  'city',
  'phone',
  'email',
  'contact_email',
  'label_title',
  'label_address',
  'pharmacy_logo',
  'prescription_provider_email',
  'stock_management_articles',
  'dhl_billing_number',
  'dhl_shipper_name',
  'dhl_shipper_address_street',
  'dhl_shipper_city',
  'dhl_shipper_postalcode',
  'dhl_username',
  'dhl_password'
];

const insurance_state_values = [
  { label: 'GKV', value: 'gkv_cost_coverage' },
  { label: 'PKV', value: 'pkv' },
  { label: 'Selbstzahler', value: 'selbstzahler' }
];

const productItemFields = {
  id: null,
  type: null,
  amount: null,
  unit: null
};
const csvDraftExportFields = {
  orders_id: 'Id',
  customer_id: 'Ext Id',
  customer_firstname: 'Vorname',
  customer_lastname: 'Nachname',
  status: 'Status',
  date_created: 'Reservierungsdatum',
  preferred_date_of_delivery: 'Lieferdatum',
  delivery_type: 'Lieferart',
  delivery_period: 'Lieferzeitfenster',
  tracking_number: 'Sendungsnummer',
  payment_type: 'Zahlungsart',
  customer_insurance_state: 'Versichertenstatus',
  group: 'Kundengruppe ',
  source: 'Bestellungsquelle',
  external_order_id: 'Externe OrderID',
  payment_amount: 'Rechnungsbetrag',
  items: 'Produkte',
  amount: 'Menge',
  product_id: 'Product ID',
  desired_date: 'Wunschdatum',
  location: 'Abholort',
};

const budInventoryFields = [
  'id',
  'type',
  'product_id',
  'pzn',
  'pzn_assignment',
  'internal_item_name',
  'automatic_inventory',
  'availability',
  'visibility',
  'netpurchaseprice',
  'remaining_amount',
  'expiry',
  'url',
  'wording_dispensing',
  'wording_dispensing_alternate',
  'packaging',
  'packaging_unit',
  'suppliers.*',
  'prescription_provider'
];
const extractInventoryFields = [
  'id',
  'type',
  'product_id',
  'pzn',
  'pzn_assignment',
  'internal_item_name',
  'automatic_inventory',
  'availability',
  'visibility',
  'netpurchaseprice',
  'remaining_amount',
  'expiry',
  'url',
  'wording_dispensing',
  'wording_dispensing_alternate',
  'packaging',
  'packaging_unit',
  'suppliers.*',
  'conf_special_concentration_steps',
  'conf_max_concentration'
];

const orderActivityLogIntersectionKeys = [
  'ext_invoice_number',
  'payment_amount',
  'status',
  'customer',
  'location',
  'status',
  'handover_delivery_date',
  'preferred_date_of_delivery',
  'delivery_period',
  'delivery_type',
  'date_of_invoice',
  'date_of_payment',
  'payment_type',
  'payment_status',
  'payment_term'
];
const orderSourceOptions = [
  { label: 'Post', value: 'post' },
  { label: 'Web / Mail', value: 'web_mail' },
  { label: 'Persönlich', value: 'personlich' },
  { label: 'Canngo', value: 'canngo' },
  { label: 'TePo Ansay', value: 'ansay' },
  { label: 'n.a.', value: null }
];
const csvDraftExportFieldOptions = () => {
  const out = [];
  const keys = Object.keys(csvDraftExportFields);
  const length = keys.length - 1;
  let locationOption = null;

  for (let i = 0; i <= length; i++) {
    const key = keys[i];
    const option = { value: key, label: csvDraftExportFields[key] };

    if (key == 'location') {
      locationOption = option;
    } else {
      out.push(option);
    }
  }

  if (locationOption) {
    out.push(locationOption);
  }
  return out;
};
const csvExportFieldOptions = () => {
  const out = [];
  const keys = Object.keys(csvExportFields);
  const length = keys.length - 1;
  for (let i = 0; i <= length; i++) {
    out[out.length] = { value: keys[i], label: csvExportFields[keys[i]] };
  }
  return out;
};

const csvExportFields = {
  orders_id: 'Id',
  customer_id: 'Ext Id',
  customer_firstname: 'Vorname',
  customer_lastname: 'Nachname',
  status: 'Status',
  date_created: 'Reservierungsdatum',
  preferred_date_of_delivery: 'Lieferdatum',
  delivery_type: 'Lieferart',
  delivery_period: 'Lieferzeitfenster',
  tracking_number: 'Sendungsnummer',
  payment_type: 'Zahlungsart',
  customer_insurance_state: 'Versichertenstatus',
  group: 'Kundengruppe ',
  source: 'Bestellungsquelle',
  external_order_id: 'Externe OrderID',
  payment_amount: 'Rechnungsbetrag',
  items: 'Produkte',
  amount: 'Menge',
  product_id: 'Product ID',
  id: 'Bestellung-URL',
  on_site_payment: 'vor Ort Zahlung',
  payment_status: 'Zahlungsstatus',
  location: 'Abholort',
  // payment_amount: 'Summe',
  //payment_status: 'Zahlungsstatus',
};

const init_column_orders = {
    "Id": { "name": "Id", "required": true, id: 1 },
    "Name": { "name": "Name", "required": true, id: 2 },
    "Status": { "name": "Status", "required": true, id: 3 },
    "Reservierungsdatum": { "name": "Reservierungsdatum", "required": true, id: 4 },
    "Bearbeiter": { "name": "Bearbeiter", "required": true, id: 6 },
    "Zahlungseingänge": { "name": "Zahlungseingänge", "required": true, id: 7 },
    "Lieferart": { "name": "Lieferart", "required": true, id: 8 },
    "Kommentare": { "name": "Kommentare", "required": true, id: 9 },
    "Liefertag / Datum": { "name": "Liefertag / Datum", "required": true, id: 10 },
    "Lieferzeitfenster": { "name": "Lieferzeitfenster", "required": true, id: 11 },
    "Versichertenstatus": { "name": "Versichertenstatus", "required": true, id: 12 },
    "Bestellungsquelle": { "name": "Bestellungsquelle", "required": true, id: 13 },
    "Externe OrderID": { "name": "Externe OrderID", "required": true, id: 13.5 },
    "Kundengruppe": { "name": "Kundengruppe", "required": true, id: 14 },
    "Abholort": { "name": "Abholort", "required": true, id: 15 }
}

const additional_column_orders = {
  "Eingangsdatum": { "name": "Eingangsdatum", "required": true, id: 5 },
  "Rechnungsdatum": { "name": "Rechnungsdatum", "required": true, id: 17 },
  "Rechnungsnummer": { "name": "Rechnungsnummer", "required": true, id: 18 },
  "Auflösungsdatum": { "name": "Auflösungsdatum", "required": true, id: 19 },
}

const init_columns_reservations = {
  "Id": { "id": 1, "name": "Id", "required": true },
  "Name": { "id": 2, "name": "Name", "required": true },
  "Kundengruppe": { "id": 3, "name": "Kundengruppe", "required": true },
  "Bestellungsquelle": { "id": 4, "name": "Bestellungsquelle", "required": true },
  "Externe OrderID": { "id": 4.5, "name": "Externe OrderID", "required": true },
  "Reservierungsdatum": { "id": 5, "name": "Reservierungsdatum", "required": true },
  "Zahlungseingänge": { "id": 5.5, "name": "Zahlungseingänge", "required": true },
  "Lieferart": { "id": 6, "name": "Lieferart", "required": true, },
  "Kommentare": { "id": 7, "name": "Kommentare", "required": true },
  "Versichertenstatus": { "id": 8, "name": "Versichertenstatus", "required": true },
  "Wunschdatum": { "id": 9, "name": "Wunschdatum", "required": true },
  "Abholort": { "id": 10, "name": "Abholort", "required": true }
}
const init_columns_extracts = {
  "Extrakte": { "required": true, "name": "Extrakte", "id": 2 },
  "Preis_pro_Ml": { "required": true, "name": "Preis pro ml", "id": 3 },
  "Netto_EK_pro_Ml": { "id": 3.5, "required": true, "name": "Netto EK pro ml" },
  "Verfugbarkeit": { "required": true, "name": "Verfügbarkeit", "id": 4 },
  "Ist_Bestand": { "required": true, "name": "Ist Bestand", "id": 5 },
  "Virtueller_Bestand": { "required": true, "name": "Virtueller Bestand", "id": 6 },
  "Preisberechnung": { "required": true, "name": "Preisberechnung", "id": 7 },
  "Immer_verfugbar": { "required": true, "name": "Immer verfügbar", "id": 8 },
  "Restmenge": { "required": true, "name": "Restmenge", "id": 9 },
  "Cansativa": { "required": true, "name": "Cansativa", "id": 9.1 },
  // Hidden until a backend source exists — both still run on placeholder data.
  // "Mindestverfugbarkeit": { "required": true, "name": "Mindestverfügbarkeit (Tage)", "id": 9.2 },
  // "Einkaufsvorschlag": { "required": true, "name": "Einkaufsvorschlag", "id": 9.3 },
  "Bestellung": { "required": true, "name": "Bestellung", "id": 9.4 },
  "Kultivar": { "required": true, "name": "Kultivar", "id": 10 },
  "Verfall": { "id": 10.5, "required": true, "name": "Verfall" },
  "Genetik": { "required": true, "name": "Genetik", "id": 11 },
  "Dominanz": { "required": true, "name": "Dominanz", "id": 12 },
  "THC": { "required": true, "name": "THC", "id": 13 },
  "CBD": { "required": true, "name": "CBD", "id": 14 },
  "Hersteller": { "required": true, "name": "Hersteller", "id": 15 },
  "Herkunft": { "required": true, "name": "Herkunft", "id": 16 },
  "Reservierung": { "required": true, "name": "Ware im Zulauf / Rückstellung", "id": 17 },
  "Nicht_anzeigen": { "required": true, "name": "Nicht anzeigen", "id": 18 }
};
const init_columns_flowers = {
  "Blute": { "id": 2, "required": true, "name": "Blüte" },
  "Preis_pro_G": { "id": 3, "required": true, "name": "Preis pro g" },
  "Netto_EK_pro_G": { "id": 3.5, "required": true, "name": "Netto EK pro g" },
  "Verfugbarkeit": { "id": 4, "required": true, "name": "Verfügbarkeit" },
  "Ist_Bestand": { "id": 5, "required": true, "name": "Ist Bestand" },
  "Virtueller_Bestand": { "id": 6, "required": true, "name": "Virtueller Bestand" },
  "Preisberechnung": { "id": 7, "required": true, "name": "Preisberechnung" },
  "Immer_verfugbar": { "id": 8, "required": true, "name": "Immer verfügbar" },
  "Restmenge": { "id": 9, "required": true, "name": "Restmenge" },
  "Cansativa": { "id": 9.1, "required": true, "name": "Cansativa" },
  // Hidden until a backend source exists — both still run on placeholder data.
  // "Mindestverfugbarkeit": { "id": 9.2, "required": true, "name": "Mindestverfügbarkeit (Tage)" },
  // "Einkaufsvorschlag": { "id": 9.3, "required": true, "name": "Einkaufsvorschlag" },
  "Bestellung": { "id": 9.4, "required": true, "name": "Bestellung" },
  "Kultivar": { "id": 10, "required": true, "name": "Kultivar" },
  "Genetik": { "id": 11, "required": true, "name": "Genetik" },
  "Dominanz": { "id": 12, "required": true, "name": "Dominanz" },
  "THC": { "id": 13, "required": true, "name": "THC" },
  "CBD": { "id": 14, "required": true, "name": "CBD" },
  "Hersteller": { "id": 15, "required": true, "name": "Hersteller" },
  "Herkunft": { "id": 16, "required": true, "name": "Herkunft" },
  "Bestrahlung": { "id": 17, "required": true, "name": "Bestrahlung" },
  "Reservierung_beim_Lieferant": { "id": 18, "required": true, "name": "Ware im Zulauf / Rückstellung" },
  "Verfall": { "id": 18.5, "required": true, "name": "Verfall" },
  "Nicht_anzeigen": { "id": 19, "required": true, "name": "Nicht anzeigen" }
}

const init_columns_customers = {
  "Name": { "id": 1, "required": true, "name": "Name" },
  "Geburtsdatum": { "id": 2, "required": true, "name": "Geburtsdatum" },
  "E_Mail": { "id": 3, "required": true, "name": "E-Mail" },
  "Ext_Id": { "id": 4, "required": true, "name": "Ext. Id" },
  "Tel": { "id": 5, "required": true, "name": "Tel." },
  "Rechnungsadresse": { "id": 6, "required": true, "name": "Rechnungsadresse" },
  "Lieferadresse": { "id": 7, "required": true, "name": "Lieferadresse" },
  "SEPA_PDF": { "id": 8, "required": true, "name": "SEPA PDF" },
  "Kundengruppe": { "id": 9, "required": true, "name": "Kundengruppe" }
}

const init_column_prescriptions = {
  "Sorten": { "id": 1, "name": "Sorten", "required": true },
  "Kultivar": { "id": 2, "name": "Kultivar", "required": true },
  "Kategorie": { "id": 3, "name": "Kategorie", "required": true },
}

const additionalCsvExportFields = {
  date_inbox: 'Eingangsdatum',
  date_of_invoice: 'Rechnungsdatum',
  payment_term: 'Auflösungsdatum',
  ext_invoice_number: 'Rechnungsnummer',
}

const statusLabels = {
  processing: 'Rezept-Bearbeitung',
  inbox: 'Eingegangen',
  draft: 'Entwurf',
  laboratory: 'Labor',
  laboratory_prio: 'Labor-Prio',
  ready_to_ship: 'Versandbereit',
  sent: 'versendet / Ware übergeben',
  support: 'Callcenter',
  support_prio: 'Callcenter-Prio',
  approval: 'Gurkentisch',
  subsequent_delivery: 'Nachlieferung',
  split_delivery: 'Teilbelieferung',
  no_date_of_delivery: 'Freigegeben - ohne Liefertermin',
  released_consultation: 'Freigegeben - Rücksprache',
  cancellation: 'Storno',
};

const ProductMovementsReportHeaders = [
  "Buchungsdatum",
  "Product ID (UUID)",
  "Produktname",
  "PZN",
  "Buchungsgrund",
  "Menge (g/ml/Stk.)",
  "Verwendbarkeitsfrist",
  "Charge",
  "Rechnungsnummer",
  "Rechnungsdatum",
  "Netto EK/Einheit",
  "Brutto VK/Einheit",
  "Bestell-Nummer",
  "Status",
  "Kundennummer",
  "Ist-Bestand vor Buchung",
  "Ist- Bestand nach Buchung"
];

const manualStockChangeReasonLabels = {
  destroyed: 'Vernichtet',
  inventory_audit: 'Inventur',
  underfill: 'Unterfüllung',
  overfill: 'Überfüllung',
  manufacturer_returns: 'Hersteller-Retouren',
  replacement_delivery: 'Ersatzlieferung',
  incoming_goods: 'Wareneingang',
  other: 'Eigener Grund',
};

const orderStockLogReasonLabels = {
  sale: 'Verkauf',
  cancellation: 'Storno',
};

const productMovementEndOrderStatuses = ['ready_to_ship', 'sent', 'cancellation'];

const InventoryChangesReportHeaders = [
  "Name",
  "PZN",
  "ChargenNr.",
  "Änderungsgrund",
  "Änderungsdatum",
  "Mitarbeiter",
  "Menge",
  "Rechnungsnummer",
  "Rechnungsbetrag (EUR)",
  "Rechnungsdatum",
  "Kommentar",
  "Apotheke",
  "Erstellungsdatum",
  "Auswertungszeitraum"
];

// Hidden labor report (DA-3-6375): CRM users allowed to click the Bestelldaten title
const laboratoryOrdersReportUserIds = [
  "3f198463-3145-44ef-90f0-033242ed2e8f",
  "079b17df-bb98-442b-9771-535d394455b9",
  "b3aa7d88-d36e-4fff-850e-23f9ef88f21d",
  "3f53f84f-4ddf-4d4c-9870-eeec611336fa",
  "258e90fa-b848-4439-8391-a4aa64581b4a"
];

// One row per order item; the order columns repeat for every item of that order
const laboratoryOrdersReportHeaders = [
  "Bestellungs-UUID",
  "Id",
  "Vorname",
  "Nachname",
  "Status",
  "Lieferart",
  "Produktnamen",
  "Kultivare",
  "Mengen",
  "ChargenNr.",
  "Bestellung-URL",
  "Reservierungsdatum"
];

const ReportOrderPharciesHeaders = [
  "Interne Bestellnummer",
  "Datum",
  "Fertigstellungsdatum",
  "Produktname",
  "Menge (g/ml/Stk.)",
  "Reichweite",
  "Transaktionscode",
  "Bruttoverkaufspreis €/Einheit",
  "Nettoverkaufspreis €/Einheit",
  "Nettoverkaufspreis (gesamt)",
  "Nettoeinkaufspreis €/Einheit",
  "Nettoeinkaufspreis (gesamt)",
  "Bruttoverkaufspreis (gesamt)",
  "Gesamtwert der Bestellung",
  "Rohertrag",
  "Marge €/Einheit",
  "Hersteller",
  "Darreichungsform",
  "Genetik",
  "Dominanz",
  "Kultivar",
  "Charge-Nr.",
  "Verfallsdatum",
  "KundenID",
  "PLZ",
  "Stadt",
  "Lieferart",
  "ProduktID",
  "Status",
  "Bestellungsquelle",
  "Versichertenstatus",
  "Sendungsnummer",
  "Apotheke",
  "Erstellungsdatum",
  "Auswertungszeitraum"
];

const exportProductsStockHeaders = [
  "Produktname",
  "Kultivar / Variant",
  "UUID",
  "PZN",
  "Batch Numbers",
  "Verfügbarkeit",
  "Ist-Bestand (g)",
  "Virtueller Bestand (g)",
  "Nettoeinkaufspreis (EUR)",
  "Verfall",
  "Apotheke",
  "Erstellungsdatum",
  "Auswertungszeitraum"
];

const CardFloPaymentsHeaders = [
  "WWC Rechnungsnummer",
  "WWC Bestellnummer",
  "WWC Bestell ID",
  "WWC Kundenname",
  "cardHolderName",
  "customerName",
  "issuer",
  "acquirerRespMsg",
  "status",
  "txnAmount",
  "txnReference",
  "paymentModeValue",
  "paymentMode",
  "transactionDate (Date)",
  "transactionDate (Time)"
];

const customerCsvExportFieldOptions = [
  { value: 'ext_customer_id', label: 'Externe Kunden-ID' },
  { value: 'firstname', label: 'Vorname' },
  { value: 'lastname', label: 'Nachname' },
  { value: 'date_of_birth', label: 'Geburtsdatum' },
  { value: 'email', label: 'E-Mail' },
  { value: 'phone', label: 'Telefonnummer' },
  { value: 'group', label: 'Kundengruppe' },
  { value: 'payment_preference', label: 'Zahlungspräferenz' },
  { value: 'insurance_state', label: 'Versichertenstatus' },
  { value: 'date_created', label: 'Erstellt am' },
  { value: 'date_updated', label: 'Aktualisiert am' },
  { value: 'user_updated', label: 'Bearbeitet von' },
  { value: 'orders_count', label: 'Bestellungen gesamt' },
  { value: 'pharmacy_remarks', label: 'Interne Hinweise' },
  { value: 'invoice_customer', label: 'Rechnungskunde' },
  { value: 'billing_street', label: 'Straße' },
  { value: 'billing_house_number', label: 'Hausnummer' },
  { value: 'billing_zip', label: 'PLZ' },
  { value: 'billing_city', label: 'Ort' },
  { value: 'billing_additional', label: 'Weitere Angaben' },
  { value: 'delivery_firstname', label: 'Vorname (Lieferadresse)' },
  { value: 'delivery_lastname', label: 'Nachname (Lieferadresse)' },
  { value: 'delivery_street', label: 'Straße (Lieferadresse)' },
  { value: 'delivery_house_number', label: 'Hausnr. (Lieferadresse)' },
  { value: 'delivery_zip', label: 'PLZ (Lieferadresse)' },
  { value: 'delivery_city', label: 'Ort (Lieferadresse)' },
  { value: 'delivery_additional', label: 'Weitere Angaben (Lieferadresse)' }
];

exports.customerCsvExportFieldOptions = customerCsvExportFieldOptions;
exports.exportProductsStockHeaders = exportProductsStockHeaders;
exports.ReportOrderPharciesHeaders = ReportOrderPharciesHeaders;
exports.laboratoryOrdersReportUserIds = laboratoryOrdersReportUserIds;
exports.laboratoryOrdersReportHeaders = laboratoryOrdersReportHeaders;
exports.CardFloPaymentsHeaders = CardFloPaymentsHeaders;
exports.InventoryChangesReportHeaders = InventoryChangesReportHeaders;
exports.ProductMovementsReportHeaders = ProductMovementsReportHeaders;
exports.manualStockChangeReasonLabels = manualStockChangeReasonLabels;
exports.orderStockLogReasonLabels = orderStockLogReasonLabels;
exports.productMovementEndOrderStatuses = productMovementEndOrderStatuses;
exports.variableSuggestionJSON = variableSuggestionJSON;
exports.PREPAID_CONDITIONAL_BASE_TAGS = PREPAID_CONDITIONAL_BASE_TAGS;
exports.additionalCsvExportFields = additionalCsvExportFields;
exports.orderActivityLogIntersectionKeys = orderActivityLogIntersectionKeys;
exports.budInventoryFields = budInventoryFields;
exports.extractInventoryFields = extractInventoryFields;
exports.constants = constants;
exports.mappedOrderFields = mappedOrderFields;
exports.CARDFLO_ORDER_RESET_FIELDS = CARDFLO_ORDER_RESET_FIELDS;
exports.CARDFLO_V2_OPERATION = CARDFLO_V2_OPERATION;
exports.isCardfloV2Enabled = isCardfloV2Enabled;
exports.isOrderOnCardfloV2 = isOrderOnCardfloV2;
exports.ORDER_REALTIME_SUBSCRIBE_FIELDS = ORDER_REALTIME_SUBSCRIBE_FIELDS;
exports.ORDER_REALTIME_SUBSCRIBE_FIELDS_FOR_SINGLE_ORDER = ORDER_REALTIME_SUBSCRIBE_FIELDS_FOR_SINGLE_ORDER;
exports.mappedBudsFields = mappedBudsFields;
exports.mappedExtractFields = mappedExtractFields;
exports.userFields = userFields;
exports.mainPharmacyFields = mainPharmacyFields;
exports.greenersUserFields = greenersUserFields;
exports.meRequestFields = meRequestFields;
exports.packagingUnitOptions = packagingUnitOptions;
exports.equalityOptions = equalityOptions;
exports.geneticOptions = geneticOptions;
exports.geneticdominanceOptions = geneticdominanceOptions;
exports.unitOptions = unitOptions;
exports.calculationBaseOptions = calculationBaseOptions;
exports.extractOutputTypeOptions = extractOutputTypeOptions;
exports.baseOilOptions = baseOilOptions;
exports.manufacturingprocessOptions = manufacturingprocessOptions;
exports.productItemFields = productItemFields;

exports.insuranceStateValues = insurance_state_values;
exports.orderSourceOptions = orderSourceOptions;
exports.csvDraftExportFieldOptions = csvDraftExportFieldOptions;
exports.csvExportFieldOptions = csvExportFieldOptions;
exports.csvExportFields = csvExportFields;
exports.orderActivityLogIntersectionKeys = orderActivityLogIntersectionKeys;
exports.budInventoryFields = budInventoryFields;
exports.extractInventoryFields = extractInventoryFields;
exports.csvExportFieldOptions = csvExportFieldOptions;
exports.csvExportFields = csvExportFields;
exports.csvDraftExportFields = csvDraftExportFields;
exports.geneticdominanceOptions = geneticdominanceOptions;
exports.unitOptions = unitOptions;
exports.calculationBaseOptions = calculationBaseOptions;
exports.extractOutputTypeOptions = extractOutputTypeOptions;
exports.baseOilOptions = baseOilOptions;
exports.manufacturingprocessOptions = manufacturingprocessOptions;
exports.productItemFields = productItemFields;
exports.radiotionOptions = radiotionOptions;
exports.insuranceStateValues = insurance_state_values;
exports.orderSourceOptions = orderSourceOptions;
exports.csvDraftExportFieldOptions = csvDraftExportFieldOptions;
exports.init_column_orders = init_column_orders;
exports.init_columns_reservations = init_columns_reservations;
exports.init_columns_extracts = init_columns_extracts;
exports.init_columns_flowers = init_columns_flowers;
exports.init_columns_customers = init_columns_customers;
exports.init_column_prescriptions = init_column_prescriptions;
exports.additional_column_orders = additional_column_orders;
exports.statusLabels = statusLabels;
